import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ArrowBackIosIcon(props: FixMe) {
  return <ArrowBackIos {...props} />;
}

export default ArrowBackIosIcon;
